// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__11bhc","Label":"BuildControl_Label__-lIvM","Less":"BuildControl_Less__XDfUJ","More":"BuildControl_More__3-I8X"};